import React from "react";
import {
  PrimaryButton,
} from "@fluentui/react";
import PanelActions from "components/shared/panel/PanelActions";

interface PolicyCriteriaEditPanelActionsProps {
  onApply: () => void;
  disabled?: boolean;
  isApplying?: boolean;
}

function PolicyCriteriaEditPanelActions({
  onApply,
  disabled = true,
  isApplying = false,
}: PolicyCriteriaEditPanelActionsProps) {
  return (
    <PanelActions>
      <PrimaryButton
        data-automation-id="policy-criteria-edit-panel-action-apply-button"
        onClick={onApply}
        disabled={disabled || isApplying}
        styles={{
          root: {
            marginRight: "8px",
          },
        }}
      >
        {isApplying ? "Applying..." : "Apply"}
      </PrimaryButton>
    </PanelActions>
  );
}

export default PolicyCriteriaEditPanelActions;